import * as React from 'react';
import styled from '../../../utils/styled';
import {withTheme} from 'emotion-theming';
import {Theme} from '../../../theme';

interface InputIconProps {
  icon: React.ReactNode;
  position: 'start' | 'end';
  large: boolean;
  small: boolean;
}

const Root = styled('span')<{position: 'start' | 'end'}>(({position}) => ({
  position: 'absolute',
  zIndex: 2,
  left: position === 'start' ? 12 : 'auto',
  right: position === 'end' ? 12 : 'auto',
  top: '50%',
  transform: 'translateY(-50%)',
  lineHeight: 0,
  color: 'rgba(0,0,0,0.25)'
}));

class InputIcon extends React.Component<InputIconProps & {theme?: Theme}, {}> {
  public render() {
    // tslint:disable-next-line:no-any
    const icon = React.cloneElement(this.props.icon as React.ReactElement<any>, {size: this._iconSize});

    return <Root position={this.props.position}>{icon}</Root>;
  }

  private get _iconSize() {
    const {small, large, theme} = this.props;
    const size = small ? 'small' : large ? 'large' : 'base';

    return theme!.textField.iconSize[size];
  }
}

export default withTheme(InputIcon);



// WEBPACK FOOTER //
// ./src/components/TextField/private/TextFieldIcon.tsx